import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { CountdownTimerDisplay } from '../../../components/countdownTimer/countdownTimerDisplay';
import { useAppSelector } from '../../../redux/store';
import { YELLOW_COLOR } from '../../../styles/colors';
const CONTAINER_CSS = css `
  color: white;
  white-space: nowrap;
  flex-grow: 1;
  text-align: right;
`;
export const AutoMttStagingTimerContainer = () => {
    const autoMttTimerEndTimestampMs = useAppSelector((state) => state.mttStaging.autoMttTimerEndTimestampMs);
    const hasMttStagingTables = useAppSelector((state) => !!state.mttStaging.mttStagingTables.length);
    if (autoMttTimerEndTimestampMs === undefined) {
        return null;
    }
    if (hasMttStagingTables) {
        // if there are tables to display, it means the MTT has started, so don't render the timer
        return null;
    }
    return (_jsxs(Typography, { component: 'div', css: CONTAINER_CSS, children: ["Starts in", ' ', _jsx(CountdownTimerDisplay, { endTimestampMs: autoMttTimerEndTimestampMs, color: YELLOW_COLOR, digitWidth: 9 })] }));
};
